const leaveOnlyRejectedContracts = contract =>
  contract.status.rejection &&
  contract.status.rejection.with_new_caregiver !== null

const putLatestRejectedContractInTheEnd = (a, b) =>
  new Date(a.status.rejection.rejected_at) -
  new Date(b.status.rejection.rejected_at)

const checkFirstAppointment = date =>
  new Date(date).getTime() < new Date().getTime()

const getMonthsBetweenTwoDates = (date1, date2) => {
  let months

  months = (date2.getFullYear() - date1.getFullYear()) * 12
  months -= date1.getMonth() + 1
  months += date2.getMonth()

  if (date1.getDate() >= date2.getDate()) {
    months += 1
  }

  return months <= 0 ? 0 : months
}

const filterBEData = contracts =>
  contracts.map(contract => {
    const {
      caregiver: { email, customer_count, name },
      created_at,
      first_appointment,
      contract_id,
    } = contract

    let {
      caregiver: { phone, profile_image },
      gross_booking_price_per_hour_in_cents: price,
    } = contract

    const months_of_help = getMonthsBetweenTwoDates(
      new Date(),
      new Date(created_at),
    )

    const is_first_appointment_happened = checkFirstAppointment(
      first_appointment.date,
    )

    phone = `+${phone}`
    profile_image = `https://s3.eu-central-1.amazonaws.com/static.careship.de/user/image/${profile_image}/200w.jpg`
    price /= 100 // converting to euros from cents

    return {
      name,
      email,
      phone,
      customer_count,
      price,
      months_of_help,
      created_at,
      profile_image,
      first_appointment,
      is_first_appointment_happened,
      contract_id,
    }
  })

const filterCanceledBEData = contracts =>
  contracts.map(contract => {
    const {
      caregiver: { name },
      status,
      contract_id,
    } = contract

    let {
      caregiver: { profile_image },
    } = contract

    profile_image = `https://s3.eu-central-1.amazonaws.com/static.careship.de/user/image/${profile_image}/200w.jpg`

    return { name, profile_image, status, contract_id }
  })

export default {
  serviceRequests: state => state.serviceRequests,

  pendingSRs: (state, { serviceRequests }) =>
    serviceRequests.filter(sr => sr.status === 'waiting'),

  canceledSRs: (state, { serviceRequests }) =>
    serviceRequests.filter(sr => sr.status === 'canceled'),

  contracts: state => state.contracts,

  activeContracts: (state, { contracts }) =>
    filterBEData(
      contracts.filter(
        ({ status }) =>
          status.name === 'active' &&
          status.rejection &&
          status.rejection.with_new_caregiver === null,
      ),
    ),

  alreadyCanceledContracts: (state, { contracts }) =>
    contracts.filter(contract => contract.status.name === 'canceled'),

  toBeCanceledContracts: (state, { contracts }) =>
    contracts.filter(
      contract => contract.status.name === 'scheduled_to_be_canceled',
    ),

  canceledContracts: (
    state,
    { alreadyCanceledContracts, toBeCanceledContracts },
  ) =>
    filterCanceledBEData(
      alreadyCanceledContracts.concat(toBeCanceledContracts),
    ),

  lastRejectedByCarereceiverContract: (state, { contracts }) => {
    const rejectedContracts = contracts
      .filter(leaveOnlyRejectedContracts)
      .sort(putLatestRejectedContractInTheEnd)

    if (!rejectedContracts.length) {
      return null
    }

    const latestRejected = rejectedContracts[rejectedContracts.length - 1]

    const {
      caregiver,
      status: { rejection },
    } = latestRejected

    return { caregiver, rejection }
  },
}
